import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import { HELPER, CONSTANTS } from "../../utils";
import { alertActions } from "../../store/actions";
import { useCustomAlerts, useToaster } from "../../hooks";

let timeoutTime

function AlertComponent() {
  let dispatch = useDispatch();
  let { addToast, removeAllToasts } = useToaster();

  const { form_type } = useSelector(state => state.cart.payment_method);
  const { message, hide, type, clearAll, autoDismiss, group } = useSelector(state => state.alert);

  const NIFT = form_type === CONSTANTS.PAYMENT_METHOD.FORM_TYPE.CREDIT_CARD.NIFT;
  const QISSTPAY = form_type === CONSTANTS.PAYMENT_METHOD.FORM_TYPE.CREDIT_CARD.QISSTPAY;

  useEffect(() => {
    // returned function will be called on component unmount
    return () => {
      if (!HELPER.isEmpty(message) && hide && !NIFT) {
        HELPER.scrollScreen()

        if (QISSTPAY) {
          timeoutTime = setTimeout(() => {
            dispatch(alertActions.clear())
          }, 5000);
        } else {
          dispatch(alertActions.clear())
        }
      }
      clearTimeout(timeoutTime);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    removeAllToasts();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [clearAll]);

  useEffect(() => {
    /*
      TOAST ALERTS
    */
    if (!HELPER.isEmpty(message) &&
      !HELPER.isEmpty(type) &&
      !HELPER.sendEventToiOS("alertMessage") &&
      !HELPER.sendEventToAndroid("alertMessage")) {
      
      group === CONSTANTS.ERROR_TYPE.TOAST ?
        addToast(message, {
        appearance: type,
        autoDismiss: autoDismiss,
        })
        :
        group === CONSTANTS.ERROR_TYPE.ALERT ?
        HELPER.scrollTo("alert_classes", -100)
          :
          null
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [message, type]);

  useEffect(() => {
    if (!HELPER.isEmpty(message) && hide) {
      HELPER.scrollScreen()

      if(!NIFT){
        timeoutTime = setTimeout(() => {
          dispatch(alertActions.clear())
        }, 8000);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [alert, NIFT]);

  return useCustomAlerts();
}

export default AlertComponent;
